import EnumService from '../EnumService'

export default class TipoPlanoContaEnumService extends EnumService{

    constructor(){
        super('enumMovPlanoConta');
    }
  
  }